module.exports = __webpack_public_path__ + "img/product-ketang-kjxl-03.5272675c.png";